module.exports = "/assets/image-hero.jpg?qyDc/et";